export type ImageDimensions = { width: number; height: number }

export function loadImageDimensions(src: string): Promise<ImageDimensions> {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight })
    img.onerror = () => reject(new Error('Não foi possível ler as dimensões da imagem'))
    img.src = src
  })
}

export function isAspectRatioClose(
  width: number,
  height: number,
  targetRatio: number,
  tolerance = 0.15,
): boolean {
  if (height <= 0) return false
  const ratio = width / height
  return Math.abs(ratio - targetRatio) / targetRatio <= tolerance
}
